import React, { useContext, useEffect, useState } from "react"
import Flatpickr from "react-flatpickr"

import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
  Spinner,
} from "reactstrap"

import Select from "react-select"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import { FormikProvider, useFormik } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import Spinners from "components/Common/Spinner"

// Service
import {
  CreateContent,
  GetContentById,
  UpdateContent,
} from "./services/Services.js"
import DatePicker from "react-datepicker"
import Error401 from "components/Error401"
import { coverManagementValidationSchema } from "./CoverManagementValidationSchema"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `cover-management`
const _pageName = `Cover Management`
const _routePermission = `cover-management`

const CoverManagementTemplate = ({
  pageView = "create",
  componentKey = "",
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? "TH"
  const qMainId = qParams.id
  const navigate = useNavigate()

  const [waitSendData, setWaitSendData] = useState(false)
  const [contentLoading, setContentLoading] = useState(false)

  // ========== Form Validation ========== //

  const initialValues = {
    contentId: "",

    // Content
    contentName: "",
    coverStart: "",
    coverEnd: "",

    coverDesktop: {},
    coverMobile: {},

    contentUpdateDate: moment().format("YYYY-MM-DD"),
    contentStatus: "active",
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: coverManagementValidationSchema,
    onSubmit: values => {
      console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
      const payload = {
        id: qMainId,
        contentId: values.contentId ? values.contentId : undefined,
        langId: qLang,
        contentName: values.contentName,
        coverStart: values.coverStart,
        coverEnd: values.coverEnd,

        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {},

        contentAttachmentData: {
          coverDesktop: values.coverDesktop,
          coverMobile: values.coverMobile,
        },
      }
      console.log("🚀 ~ onSave ~ payload:", payload)

      setWaitSendData(true)
      if (pageView === "update") {
        API.fetchUpdateContent(payload)
      } else {
        API.fetchCreateContent(payload)
      }
    },
  })

  const prefilInput = (resData = {}) => {
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentName", resData?.contentName ?? "")
    validation.setFieldValue("coverStart", resData?.coverStart ?? "")
    validation.setFieldValue("coverEnd", resData?.coverEnd ?? "")
    validation.setFieldValue("coverDesktop", resData?.contentCoverDesktop ?? "")
    validation.setFieldValue("coverMobile", resData?.contentCoverMobile ?? "")
    validation.setFieldValue(
      "contentUpdateDate",
      resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
    )
    validation.setFieldValue(
      "contentStatus",
      resData?.contentStatus ?? "active"
    )
  }

  const API = {
    fetchGetContentById: async payload => {
      try {
        const response = await GetContentById({
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          prefilInput(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
    fetchCreateContent: async (payload, pageSettingRoute) => {
      try {
        const response = await CreateContent({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              navigate(`/${_routeLink}/${qLang}`)
              window.location.reload()
            },
          })
        }
        if (resData.status == 400) {
          mAlert.info({
            title: "Alert",
            subTitle: "There is at least one active cover.",
            content: "",
            onClose: () => {
              //  alert("onClose")
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContent: async (payload, pageSettingRoute) => {
      try {
        const response = await UpdateContent({
          data: payload,
          id: payload.id,
          lang: qLang,
        })

        const resData = response.data
        if (resData.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/${qLang}/edit`)
              window.location.reload()
            },
          })
        }
        if (resData.status == 400) {
          mAlert.info({
            title: "Alert",
            subTitle: "There is at least one active cover.",
            content: "",
            onClose: () => {
              //  alert("onClose")
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      setContentLoading(true)
      API.fetchGetContentById(payload)
      // API.fetchGetContentPageSetting(componentKey)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title =
    `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  if (
    !checkScope(`${_routePermission}:create`) ||
    !checkScope(`${_routePermission}:update`) ||
    !checkScope(`${_routePermission}:view`)
  ) {
    return <Error401 />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} ${_pageName}`}
            breadcrumbItems={[
              { title: _pageName, link: "" },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          {contentLoading ? (
            <Spinners setLoading={setContentLoading} />
          ) : (
            <Row>
              <Col className="col-12">
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col className="col-8">
                        <Row>
                          <Col className="col-12">
                            <Card>
                              <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                <i className="bx bx-cube-alt"></i> Information
                                Box
                              </h5>
                              <CardBody>
                                <Row>
                                  <Col className="col-12 mb-3">
                                    <label
                                      htmlFor="contentName"
                                      className="col-md-12 col-form-label"
                                    >
                                      Cover name
                                      <span className="t-require">*</span>
                                    </label>
                                    <div className="col-md-12">
                                      <Input
                                        id="contentName"
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name="contentName"
                                        onChange={e => {
                                          validation.setFieldValue(
                                            "contentName",
                                            e.target.value
                                          )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentName}
                                        invalid={
                                          validation.touched.contentName &&
                                          validation.errors.contentName
                                            ? true
                                            : false
                                        }
                                        disabled={pageView === "view"}
                                      />
                                      {validation.touched.contentName &&
                                        validation.errors.contentName && (
                                          <FormFeedback type="invalid">
                                            {validation.errors.contentName}
                                          </FormFeedback>
                                        )}
                                    </div>
                                    <hr />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col className="col-6 mb-3">
                                    <Row>
                                      <Col className="col-6 mb-3">
                                        <FormGroup>
                                          <Label
                                            for="coverStart"
                                            className="col-md-12 col-form-label"
                                          >
                                            Start Date
                                            <span className="t-require">*</span>
                                          </Label>
                                          <div className="col-md-12">
                                            <DatePicker
                                              dateFormat="yyyy-mm-dd"
                                              id="coverStart"
                                              popperClassName="z-2"
                                              className={`form-control ${
                                                !!(
                                                  validation.touched
                                                    .coverStart &&
                                                  validation.errors.coverStart
                                                ) && "is-invalid"
                                              }`}
                                              name="coverStart"
                                              autoComplete="off"
                                              selected={moment().format(
                                                "YYYY-MM-DD"
                                              )}
                                              onChange={date => {
                                                validation.setFieldValue(
                                                  "coverStart",
                                                  moment(
                                                    date,
                                                    "YYYY-MM-DD"
                                                  ).format("YYYY-MM-DD")
                                                )
                                              }}
                                              onBlur={validation.handleBlur}
                                              value={
                                                validation.values.coverStart
                                              }
                                              disabled={pageView === "view"}
                                              showMonthYearDropdown
                                            />
                                            {!!(
                                              validation.touched.coverStart &&
                                              validation.errors.coverStart
                                            ) && (
                                              <div
                                                className="invalid-feedback d-block"
                                                type="invalid"
                                              >
                                                {validation.errors.coverStart}
                                              </div>
                                            )}
                                          </div>
                                        </FormGroup>
                                      </Col>
                                      <Col className="col-6 mb-3">
                                        <FormGroup>
                                          <Label
                                            htmlFor="coverEnd"
                                            className="col-md-12 col-form-label"
                                          >
                                            End Date
                                            <span className="t-require">*</span>
                                          </Label>
                                          <div className="col-md-12">
                                            <DatePicker
                                              dateFormat="yyyy-mm-dd"
                                              id="coverEnd"
                                              popperClassName="z-2"
                                              className={`form-control ${
                                                !!(
                                                  validation.touched.coverEnd &&
                                                  validation.errors.coverEnd
                                                ) && "is-invalid"
                                              }`}
                                              name="coverEnd"
                                              autoComplete="off"
                                              selected={moment().format(
                                                "YYYY-MM-DD"
                                              )}
                                              onChange={date => {
                                                validation.setFieldValue(
                                                  "coverEnd",
                                                  moment(
                                                    date,
                                                    "YYYY-MM-DD"
                                                  ).format("YYYY-MM-DD")
                                                )
                                              }}
                                              onBlur={validation.handleBlur}
                                              value={validation.values.coverEnd}
                                              disabled={pageView === "view"}
                                              showMonthYearDropdown
                                            />
                                            {!!(
                                              validation.touched.coverEnd &&
                                              validation.errors.coverEnd
                                            ) && (
                                              <div
                                                className="invalid-feedback d-block"
                                                type="invalid"
                                              >
                                                {validation.errors.coverEnd}
                                              </div>
                                            )}
                                          </div>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6}>
                                    <div>
                                      <PopupAttachment
                                        typeDetail="single"
                                        typeUpload="ImageMap"
                                        upload="Image"
                                        prefixName="cover-desktop"
                                        label="Cover Desktop"
                                        required={true}
                                        description="description"
                                        widthSize={2160}
                                        heightSize={1140}
                                        value={validation.values.coverDesktop}
                                        onChange={(value = {}, index) => {
                                          console.log(
                                            "🚀 onChange ~ value:",
                                            value
                                          )
                                          console.log(
                                            "🚀 onChange ~ index:",
                                            index
                                          )
                                          validation.setFieldValue(
                                            "coverDesktop",
                                            value
                                          )
                                        }}
                                        onRemove={index => {
                                          console.log(
                                            "🚀 onChange ~ index:",
                                            index
                                          )
                                          validation.setFieldValue(
                                            "coverDesktop",
                                            {}
                                          )
                                        }}
                                      />
                                      {validation.touched.coverDesktop &&
                                        validation.errors.coverDesktop && (
                                          <div
                                            type="invalid"
                                            className="invalid-feedback d-block"
                                          >
                                            {validation.errors.coverDesktop}
                                          </div>
                                        )}
                                    </div>
                                    <hr />
                                  </Col>
                                  <Col md={6}>
                                    <div>
                                      <PopupAttachment
                                        typeDetail="single"
                                        typeUpload="ImageMap"
                                        upload="Image"
                                        prefixName="cover-mobile"
                                        label="Cover Mobile"
                                        required={true}
                                        description="description"
                                        widthSize={480}
                                        heightSize={1040}
                                        value={validation.values.coverMobile}
                                        onChange={(value = {}, index) => {
                                          console.log(
                                            "🚀 onChange ~ value:",
                                            value
                                          )
                                          console.log(
                                            "🚀 onChange ~ index:",
                                            index
                                          )
                                          validation.setFieldValue(
                                            "coverMobile",
                                            value
                                          )
                                        }}
                                        onRemove={index => {
                                          console.log(
                                            "🚀 onChange ~ index:",
                                            index
                                          )
                                          validation.setFieldValue(
                                            "coverMobile",
                                            {}
                                          )
                                        }}
                                      />
                                      {validation.touched.coverMobile &&
                                        validation.errors.coverMobile && (
                                          <div
                                            type="invalid"
                                            className="invalid-feedback d-block"
                                          >
                                            {validation.errors.coverMobile}
                                          </div>
                                        )}
                                    </div>
                                    <hr />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </Col>
                      <Col className="col-4">
                        <Card
                          outline
                          color="primary"
                          className="border sticky-element"
                        >
                          <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                            <i className="bx bx-check"></i> Tools Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Switch Language
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputLang
                                    widthfull
                                    pageView={pageView}
                                    forceRoute={false}
                                  />
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Written at
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputGroup>
                                    <Flatpickr
                                      className="form-control d-block"
                                      options={{
                                        dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                      }}
                                      value={
                                        validation.values.contentUpdateDate
                                          ? moment(
                                              validation.values
                                                .contentUpdateDate,
                                              "YYYY-MM-DD"
                                            ).toDate()
                                          : null
                                      }
                                      disabled={true}
                                    />
                                    <div className="input-group-append">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary docs-datepicker-trigger"
                                        disabled
                                      >
                                        <i
                                          className="fa fa-calendar"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </div>
                                  </InputGroup>
                                  {validation.touched.contentUpdateDate &&
                                    validation.errors.contentUpdateDate && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentUpdateDate}
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Display
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Select
                                    placeholder="Select Status"
                                    value={fn_helper.FNFORM.getObjectValue(
                                      STATUS_OPTION,
                                      `${validation.values.contentStatus}`
                                    )}
                                    onChange={value =>
                                      validation.setFieldValue(
                                        "contentStatus",
                                        value.id
                                      )
                                    }
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={STATUS_OPTION}
                                    className={`select2-selection ${
                                      validation.touched.contentStatus &&
                                      validation.errors.contentStatus
                                        ? "input-err"
                                        : ""
                                    }`}
                                    isDisabled={pageView === "view"}
                                  />
                                  {validation.touched.contentStatus &&
                                    validation.errors.contentStatus && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentStatus}
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardFooter>
                            <Row>
                              <Col className="text-start">
                                <Button
                                  color="danger"
                                  className="btn btn-danger"
                                  onClick={() =>
                                    navigate(`/${_routeLink}/${qLang}`)
                                  }
                                >
                                  Back
                                </Button>
                              </Col>
                              <Col className="text-end">
                                {pageView !== "view" && (
                                  <Button
                                    type="submit"
                                    className="btn btn-success"
                                  >
                                    Save{" "}
                                    {waitSendData ? (
                                      <Spinner size="sm" color="light" />
                                    ) : null}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(CoverManagementTemplate)
